import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DetailView from '../Common/DetailView';
import StatementStore from '../../stores/StatementStore';
import LRS from '../../utils/LRS';
import { Container } from 'flux/utils';
import LinearProgress from 'material-ui/LinearProgress';
import { List } from 'material-ui/List';
import StatementListItem from './StatementListItem';

// import { getStatements } from '../../actions/StatementActionCreator';
const style = {
    list: {
        paddingBottom: 0,
    },
};

class StatementList extends Component {

    componentDidMount() {
        LRS.getStatements({verb: this.props.verb});
    }

    render() {
        return (
            <DetailView
                title={`Activities (${this.props.verb})`}
            >
                <div className="cent-list-wrapper">
                    <List style={style.list} className="cent-list">
                        {this.state.statements.map(statement => <StatementListItem statement={statement} key={statement.id} />)}
                    </List>
                </div>
                {this.state.isFetching && <LinearProgress />}
            </DetailView>
        );
    }
}

StatementList.propTypes = {
    verb: PropTypes.string
};

StatementList.defaultProps = {
    verb: null
};

StatementList.getStores = () => ([StatementStore]);
StatementList.calculateState = (prevState) => ({
    isFetching: StatementStore.isFetching(),
    statements: StatementStore.getStatements(),
});

export default Container.create(StatementList);
